import { Typography } from '@mui/material';
import Grid from 'components/core/Grid';
import { CheckoutSectionTitle } from 'components/views/pages/Checkout/components/CheckoutSectionTitle';
import LoadingSkeleton from 'components/core/LoadingSkeleton/LoadingSkeleton';

interface Props {
  isLoading: boolean;
}

export const CheckoutInstantBooking = ({ isLoading }: Props) => {
  return (
    <Grid item xs={12}>
      <LoadingSkeleton isLoading={isLoading} scaleOneToOne>
        <CheckoutSectionTitle>Instant Book Enabled</CheckoutSectionTitle>
      </LoadingSkeleton>
      <LoadingSkeleton isLoading={isLoading}>
        <Typography variant="body1">
          This property is set to instant booking. Your credit card will be
          charged and the booking will be confirmed.
        </Typography>
      </LoadingSkeleton>
    </Grid>
  );
};
